import { useEndSession } from 'hooks/useEndSession';
import { MultiVoipProps } from './MultiVoip';
import MultiVoipInternal from './MultiVoipInternal';

const MultiVoipWithRouting: React.FC<MultiVoipProps> = ({ controls, className }) => {
  const onEndSession = useEndSession();

  return <MultiVoipInternal controls={controls} className={className} onEndSession={onEndSession} />;
};

export default MultiVoipWithRouting;
